import { Box, Container as MuiContainer, css, styled, Typography } from "@mui/material";

const PREFIX = "jg-home-image-gallery-item";
export const classes = {
  root: PREFIX,
};

export const Container = styled(Box)`
  position: relative;
  height: calc(100vh - var(--jg-player-height) + var(--jg-home-image-gallery-border-radius));
  background-position: 64% 0;
  background-size: cover;
`;

export const ImageOverlay = styled(Box)(({ theme }) => css`
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 30%,
    rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.8) 100%
  );
`);

export const Content = styled(MuiContainer)(({ theme }) => css`
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(
    ${theme.jgComponents.Player.albumArt.sizeExpanded + 32}px
    - var(--jg-player-height)
    + var(--jg-home-image-gallery-border-radius)
  );
  text-align: left;
  text-shadow: 0 0 1.5rem rgba(0, 0, 0, 0.9);

  ${theme.breakpoints.down("md")} {
    bottom: ${theme.spacing(10)};
  }
`);

export const Details = styled(Box)(({ theme }) => css`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: ${theme.spacing(1)};

  ${theme.breakpoints.down("md")} {
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: stretch;

    & > * {
      width: 100%;
    }
  }
`);

export const StationDescription = styled(Typography)(({ theme }) => css`
  color: ${theme.palette.primary.main};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeightMedium};
  text-shadow: 0 0 2rem rgba(0, 0, 0, 0.9), 0 0 0.5rem rgba(0, 0, 0, 0.8);

  ${theme.breakpoints.down("md")} {
    text-shadow: 0 0 1.5rem rgba(0, 0, 0, 1), 0 0 0.5rem rgba(0, 0, 0, 1);
  }
`) as typeof Typography;

export const Subtitle = styled(Typography)(({ theme }) => css`
  color: ${theme.palette.text.secondary};
  font-family: ${theme.typography.fontFamily};
  font-weight: ${theme.typography.fontWeightRegular};
  text-align: right;
  text-shadow: 2px 2px 5px #000000;

  ${theme.breakpoints.down("md")} {
    margin-top: ${theme.spacing(1)};
  }
`) as typeof Typography;
